import React, { ComponentProps } from "react";
import { cn } from "utils/utils";
import { Dock } from "./Dock";

interface DockSkeletonItem {
  icon: React.ReactNode;
  label: string;
  isActive?: boolean;
  showBadgeSkeleton?: boolean;
}

interface DockSkeletonProps
  extends Pick<ComponentProps<typeof Dock>, "size" | "className"> {
  items: DockSkeletonItem[];
}

export function DockSkeleton({ items, size, className }: DockSkeletonProps) {
  return (
    <Dock size={size} className={className}>
      {items.map((item) => (
        <div key={item.label} className={cn(item.isActive && "dock-active")}>
          {item.icon}
          <span className="flex items-center gap-1">
            {item.label}
            {item.showBadgeSkeleton && (
              <span className="skeleton badge badge-xs h-4 w-4 rounded-full" />
            )}
          </span>
        </div>
      ))}
    </Dock>
  );
}
